import React from 'react';
import PropTypes from 'prop-types';
import isFunction from 'lodash/isFunction';
import isNumber from 'lodash/isNumber';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import { DropdownIcon } from 'sharedComponents/Icons';
import cx from 'classnames';

import Typography from '@material-ui/core/Typography';

const Accordion = ({ classes, items, activeItemHandler, onAnimationFinished, unpaddedContent }) => {
  const initiallyExpandedItem = items.find(({ expandedByDefault }) => expandedByDefault);
  const initiallyExpandedIndex = items.indexOf(initiallyExpandedItem);
  const [expandedId, setExpandedId] = React.useState(initiallyExpandedIndex || null);

  const handleChange = (panelId, alwaysOpen) => () => {
    if (alwaysOpen) return;
    const currentExpandedId = expandedId !== panelId ? panelId : null;
    setExpandedId(currentExpandedId);
    if (isFunction(activeItemHandler)) {
      activeItemHandler(isNumber(currentExpandedId) ? currentExpandedId : null);
    }
  };

  const TransitionProps = {
    onEntered: () => {
      if (isFunction(onAnimationFinished)) {
        onAnimationFinished();
      }
    },
  };

  const renderContent = (content) => (typeof content === 'string' ? <Typography>{content}</Typography> : content);

  return (
    <>
      {!!items?.length &&
        items.map((item, index) => {
          const itemId = index;
          return (
            <ExpansionPanel
              key={itemId}
              expanded={item.alwaysOpen || expandedId === itemId}
              onChange={handleChange(itemId, item.alwaysOpen)}
              TransitionProps={TransitionProps}
              classes={{
                root: classes.accordionItem,
              }}
            >
              <ExpansionPanelSummary
                expandIcon={item.alwaysOpen ? null : <DropdownIcon className={classes.dropdownIcon} />}
                aria-controls={itemId}
                id={itemId}
                classes={{
                  root: classes.accordionSummary,
                  content: cx(classes.summaryContent, unpaddedContent && classes.unpaddedSummaryContent),
                }}
              >
                <Typography variant="body2">{item.name}</Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails
                classes={{
                  root: classes.accordionContent,
                }}
              >
                {renderContent(item.content)}
              </ExpansionPanelDetails>
            </ExpansionPanel>
          );
        })}
    </>
  );
};

Accordion.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  /** List of items that will be rendered */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      content: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
      alwaysOpen: PropTypes.bool,
    }),
  ),
  activeItemHandler: PropTypes.func,
  onAnimationFinished: PropTypes.func,
  unpaddedContent: PropTypes.bool,
};

Accordion.defaultProps = {
  items: [],
  activeItemHandler: () => null,
  unpaddedContent: false,
};

export default Accordion;
